import Vue from 'vue'
import Router from 'vue-router'

const Index = () => import('@/pages/Index')

const ServiceAnnouncement = () => import('@/pages/app/ServiceAnnouncement')
const ReturnPolicy = () => import('@/pages/app/ReturnPolicy')
const PrivacyPolicy = () => import('@/pages/app/PrivacyPolicy')
const TermsAndConditions = () => import('@/pages/app/TermsAndConditions')
const AssemblyService = () => import('@/pages/app/AssemblyService')
const CustomerService = () => import('@/pages/app/CustomerService')
const SigninSignupFAQ = () => import('@/pages/app/SigninSignupFAQ')
const AppDownload = () => import('@/pages/app/AppDownload')
const QRCodeLandingPage = () => import('@/pages/app/QRCodeLandingPage')
const DeleteAccount = () => import('@/pages/app/DeleteAccount')
const DeleteAccountAlert = () => import('@/pages/app/DeleteAccountAlert')
const DeleteAccountStatus = () => import('@/pages/app/DeleteAccountStatus')
const ProductList = () => import('@/pages/app/ProductList')
const TrackAndTrace = () => import('@/pages/app/logistics/TrackAndTrace')
const IKEAFamily = () => import('@/pages/app/IKEAFamily')
const NewUserActivity = () => import('@/pages/app/NewUserActivity')
const promotionConfig = () => import('@/pages/app/PromotionConfig')

const OrderConfirmationNotice = () => import('@/pages/app/OrderConfirmationNotice')
const ProductShare = () => import('@/pages/app/ProductShare')
const InspirationShare = () => import('@/pages/app/InspirationShare')
const LuckyDraw = () => import('@/pages/app/LuckyDraw')
const LuckyDrawPrizeInfo = () => import('@/pages/app/LuckyDrawPrizeInfo')
const LuckyDrawResult = () => import('@/pages/app/LuckyDrawResult')
const GuaGuaLe = () => import('@/pages/app/GuaGuaLe')
const Search = () => import('@/pages/app/Search')
const Ranking = () => import('@/pages/app/Ranking')
const RankingAll = () => import('@/pages/app/RankingAll')
const Activity = () => import('@/pages/app/Activity')
const ActivityInviter = () => import('@/pages/app/ActivityInviter')
const ActivityShare = () => import('@/pages/app/ActivityShare')
const DeliveryService = () => import('@/pages/app/DeliveryService')
const TrialReport = () => import('@/pages/app/TrialReport')
const CouponActivity = () => import('@/pages/app/CouponActivity')
const D11Activity = () => import('@/pages/app/D11Activity')
const LEGO = () => import('@/pages/app/LEGO')
const CheckList = () => import('@/pages/app/CheckList')
const OpenWechatSMP = () => import('@/pages/app/OpenWechatSMP')
const ProductChildrenList = () => import('@/pages/app/ProductChildrenList')
const VirtualProductDetail = () => import('@/pages/app/VirtualProductDetail')
const VirtualProductCollage = () => import('@/pages/app/VirtualProductCollage')
const AppDownloadDemo = () => import('@/pages/app/AppDownloadDemo')

const CMSPage = () => import('@/pages/cms/Page')

const OfflineStoreTools = () => import('@/pages/offline/OfflineStoreTools')
const OfflinePromotion = () => import('@/pages/offline/OfflinePromotion')

const landingPage = () => import('@/pages/landing/Page')

const ProductScanLandingPage = () => import('@/pages/offline/ProductScanLandingPage')

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/page/privacy_policy.html',
      name: 'privacyPolicy',
      component: PrivacyPolicy,
      meta: {
        title: "宜家隐私政策"
      }
    },
    {
      path: '/page/terms_and_conditions.html',
      name: 'termsAndConditions',
      component: TermsAndConditions,
      meta: {
        title: "宜家移动应用使用条款"
      }
    },
    {
      path: '/page/return_policy.html',
      name: 'returnPolicy',
      component: ReturnPolicy,
      meta: {
        title: "退货政策"
      }
    },
    {
      path: '/page/assembly_service.html',
      name: 'assemblyService',
      component: AssemblyService,
      meta: {
        title: "组装服务详情"
      }
    },
    {
      path: '/page/delete_account.html',
      name: 'deleteAccount',
      component: DeleteAccount,
      meta: {
        title: "注销账户"
      }
    },
    {
      path: '/page/delete_account_alert.html',
      name: 'deleteAccountAlert',
      component: DeleteAccountAlert,
      meta: {
        title: "注销账户"
      }
    },
    {
      path: '/page/delete_account_status.html',
      name: 'deleteAccountStatus',
      component: DeleteAccountStatus,
      meta: {
        title: "注销账户"
      }
    },
    {
      path: '/page/customer_service.html',
      name: 'customerService',
      component: CustomerService,
      meta: {
        title: "宜家客服"
      }
    },
    {
      path: '/page/cms/page.html',
      name: 'cmsPage',
      component: CMSPage
    },
    {
      path: '/page/signin_signup_faq.html',
      name: 'signinSignupFAQ',
      component: SigninSignupFAQ,
      meta: {
        title: "登录/注册常见问题"
      }
    },
    {
      path: '/page/app_download.html',
      name: 'appDownload',
      component: promotionConfig,
      meta: {
        title: "宜家家居 APP"
      }
    },
    {
      path: '/page/app_download_store.html',
      name: 'appDownloadForStore',
      component: AppDownload,
      meta: {
        title: "宜家家居 APP"
      }
    },
    {
      path: '/page/track_and_trace.html',
      name: 'trackAndTrace',
      component: TrackAndTrace,
      meta: {
        title: "物流跟踪"
      }
    },
    {
      path: '/page/qr.html',
      name: 'qr',
      component: QRCodeLandingPage,
      meta: {
        title: "宜家IKEA"
      }
    },
    {
      path: '/page/qr_app.html',
      name: 'qrapp',
      component: QRCodeLandingPage,
      meta: {
        title: "宜家IKEA"
      }
    },
    {
      path: '/page/product_list.html',
      name: 'productList',
      component: ProductList,
      meta: {
        title: "宜家IKEA"
      }
    },
    {
      path: '/page/ikea_family.html',
      name: 'ikeaFamily',
      component: IKEAFamily,
      meta: {
        title: "宜家俱乐部"
      }
    },
    {
      path: '/page/order_confirmation_notice.html',
      name: 'orderConfirmationNotice',
      component: OrderConfirmationNotice,
      meta: {
        title: "宜家IKEA"
      }
    },
    {
      path: '/page/new_user_activity.html',
      name: 'newUserActivity',
      component: NewUserActivity,
      meta: {
        title: "活动有礼"
      }
    },
    {
      path: '/page/product_share.html',
      name: 'productShare',
      component: ProductShare,
      meta: {
        title: "分享"
      }
    },
    {
      path: '/page/inspiration_share.html',
      name: 'inspirationShare',
      component: InspirationShare,
      meta: {
        title: "分享"
      }
    },
    {
      path: '/page/lucky_draw.html',
      name: 'luckyDraw',
      component: LuckyDraw,
      meta: {
        title: "抽奖活动"
      }
    },
    {
      path: '/page/lucky_draw_prize_info.html',
      name: 'luckyDrawPrizeInfo',
      component: LuckyDrawPrizeInfo,
      meta: {
        title: "奖品信息"
      }
    },
    {
      path: '/page/lucky_draw_result.html',
      name: 'luckyDrawResult',
      component: LuckyDrawResult,
      meta: {
        title: "奖品信息"
      }
    },
    {
      path: '/page/guaguale.html',
      name: 'gua gua le',
      component: GuaGuaLe,
      meta: {
        title: " 双十一大抽奖"
      }
    },
    {
      path: '/page/activity.html',
      name: 'activity',
      component: Activity,
      meta: {
        title: "活动"
      }
    },
    {
      path: '/page/search.html',
      name: 'Search',
      component: Search,
      meta: {
        title: "搜索"
      }
    },
    {
      path: '/page/ranking.html',
      name: 'Ranking',
      component: Ranking,
      meta: {
        title: '排行榜'
      }
    },
    {
      path: '/page/ranking-all.html',
      name: 'RankingAll',
      component: RankingAll,
      meta: {
        title: '总排行榜'
      }
    },
    {
      path: '/page/activity_inviter.html',
      name: 'activityInviter',
      component: ActivityInviter,
      meta: {
        title: "邀请好友领券"
      }
    },
    {
      path: '/page/activity_share.html',
      name: 'activityShare',
      component: ActivityShare,
      meta: {
        title: "邀请好友"
      }
    },
    {
      path: '/page/delivery_service.html',
      name: 'deliveryService',
      component: DeliveryService,
      meta: {
        title: "送货服务"
      }
    },
    {
      path: '/page/offline_store_tools.html',
      name: 'offlineStoreTools',
      component: OfflineStoreTools,
      meta: {
        title: "offline store tools"
      }
    },
    {
      path: '/page/trial_report.html',
      name: 'trialReport',
      component: TrialReport,
      meta: {
        title: "好物评测"
      }
    },
    {
      path: '/page/offline_promotion.html',
      name: 'offlinePromotion',
      component: OfflinePromotion,
      meta: {
        title: "offline promotion"
      }
    },
    {
      path: '/page/coupon_activity.html',
      name: 'CouponActivity',
      component: CouponActivity,
      meta: {
        title: "领取11.11专享券！"
      }
    },
    {
      path: '/page/d11_activity.html',
      name: 'D11Activity',
      component: D11Activity,
      meta: {
        title: "10.21-11.12，指定同类商品多件多折！"
      }
    },
    {
      path: '/page/lego.html',
      name: 'LEGO',
      component: LEGO,
      meta: {
        title: "BYGGLEK 比格列克 系列"
      }
    },
    {
      path: '/page/open_wechat_smp.html',
      name: 'openWechatSMP',
      component: OpenWechatSMP,
      meta: {
        title: "打开微信小程序"
      }
    },
    {
      path: '/page/check_list.html',
      name: 'Check list',
      component: CheckList,
      meta: {
        title: "check app or mp scheme"
      }
    },
    {
      path: '/page/landing_page.html',
      name: 'Landing Page',
      component: landingPage
      // meta: {
      //   title: '落地页'
      // }
    },
    {
      path: '/page/service_announcement.html',
      name: 'ServiceAnnouncement',
      component: ServiceAnnouncement,
      meta: {
        title: '服务公告'
      }
    },
    {
      path: '/page/product_children_list.html',
      name: 'ProductChildrenList',
      component: ProductChildrenList,
      meta: {
        title: ''
      }
    },
    {
      path: '/page/product_scan_landing_page.html',
      name: 'ProductScanLandingPage',
      component: ProductScanLandingPage,
      meta: {
        title: 'IKEA'
      }
    },
    {
      path: '/page/virtual_product_detail.html',
      name: 'VirtualProductDetail.vue',
      component: VirtualProductDetail,
      meta: {
        title: '商品详情'
      }
    },
    {
      path: '/page/virtual_product_collage.html',
      name: 'VirtualProductCollage',
      component: VirtualProductCollage,
      meta: {
        title: '组合商品'
      }
    },
    {
      path: '/page/app_download_demo.html',
      name: 'AppDownloadGuideDemo',
      component: AppDownloadDemo,
      meta: {
        title: '下载App引导Demo'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js